export default "__VITE_ASSET__CKiHUi2Y__"